/**
 * React Hook Form treats `[`, `]` and `.` in field names as path segments
 * (e.g. `count[7425]` → array `count` at index 7425). API / legacy ids often
 * keep those characters. Encode only when needed so RHF stores a flat key;
 * decode when leaving the RHF boundary back to API ids.
 */

const LB = '__LB__';
const RB = '__RB__';
const DOT = '__DOT__';

/**
 * @param {string | null | undefined} apiFieldId
 * @returns {boolean}
 */
export function fieldNameNeedsEncoding(apiFieldId) {
  if (!apiFieldId) return false;
  return /[[\].]/.test(apiFieldId);
}

/**
 * API id → safe RHF field name (identity when no special chars).
 * @param {string} apiFieldId
 * @returns {string}
 */
export function encodeFieldName(apiFieldId) {
  if (!fieldNameNeedsEncoding(apiFieldId)) return apiFieldId;
  return apiFieldId
    .replaceAll('[', LB)
    .replaceAll(']', RB)
    .replaceAll('.', DOT);
}

/**
 * RHF field name → API id (identity when not encoded).
 * @param {string} rhfFieldName
 * @returns {string}
 */
export function decodeFieldName(rhfFieldName) {
  if (
    !rhfFieldName
    || (!rhfFieldName.includes(LB)
      && !rhfFieldName.includes(RB)
      && !rhfFieldName.includes(DOT))
  ) {
    return rhfFieldName;
  }
  return rhfFieldName
    .replaceAll(LB, '[')
    .replaceAll(RB, ']')
    .replaceAll(DOT, '.');
}
